import React from "react"
import { Card, CardBody, Spinner } from "reactstrap"
import moment from "moment"
import PropTypes from "prop-types"

const DashboardReportSection = ({
    reportData,
    loading,
    card1Label = "Total Leads",
    card2Label = "Cars Sold",
}) => {
    const reportTotals =
        reportData?.result?.length > 0 &&
        reportData?.result?.reduce(
            (acc, item) => {
                acc.totalLeads += item.totalLeads
                acc.social += item.social
                acc.direct += item.direct
                acc.call += item.call
                acc.website += item.website
                acc.olx += item.olx
                return acc
            },
            { totalLeads: 0, social: 0, direct: 0, call: 0, website: 0, olx: 0 }
        )

    return (
        <div>
            <div className="d-flex algin-items-center gap-3 ">
                {/* Leads Card */}
                <Card
                    style={{
                        width: "50%",
                        background: "linear-gradient(135deg, #e8f4fd 0%, #d1e9fc 100%)",
                        border: "1px solid #b8daff",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(66, 133, 244, 0.15)",
                        transition: "all 0.3s ease",
                    }}
                    className="mini-stats-wid"
                >
                    <CardBody style={{ padding: "20px" }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "12px",
                                    background:
                                        "linear-gradient(135deg, #4285f4 0%, #1a73e8 100%)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 4px 12px rgba(66, 133, 244, 0.35)",
                                }}
                            >
                                <i
                                    className="bx bx-user-plus"
                                    style={{ fontSize: "24px", color: "#fff" }}
                                ></i>
                            </div>
                            <div className="text-end">
                                <h2
                                    className="m-0 p-0"
                                    style={{
                                        fontSize: "32px",
                                        fontWeight: "700",
                                        color: "#1a73e8",
                                        lineHeight: "1",
                                    }}
                                >
                                    {reportData?.totalLeads || 0}
                                </h2>
                                <p
                                    className="m-0 mt-1"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#5a5a5a",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                    }}
                                >
                                    {card1Label}
                                </p>
                            </div>
                        </div>
                    </CardBody>
                </Card>

                {/* Car Sold/Purchased Card */}
                <Card
                    style={{
                        width: "50%",
                        background: "linear-gradient(135deg, #e8f8f0 0%, #d4f1e4 100%)",
                        border: "1px solid #a3e4c1",
                        borderRadius: "12px",
                        boxShadow: "0 4px 15px rgba(52, 168, 83, 0.15)",
                        transition: "all 0.3s ease",
                    }}
                >
                    <CardBody style={{ padding: "20px" }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "12px",
                                    background:
                                        "linear-gradient(135deg, #34a853 0%, #2d8e47 100%)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 4px 12px rgba(52, 168, 83, 0.35)",
                                }}
                            >
                                <i
                                    className="bx bx-car"
                                    style={{ fontSize: "24px", color: "#fff" }}
                                ></i>
                            </div>
                            <div className="text-end">
                                <h2
                                    className="m-0 p-0"
                                    style={{
                                        fontSize: "32px",
                                        fontWeight: "700",
                                        color: "#2d8e47",
                                        lineHeight: "1",
                                    }}
                                >
                                    {reportData?.totalCarSold || 0}
                                </h2>
                                <p
                                    className="m-0 mt-1"
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        color: "#5a5a5a",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                    }}
                                >
                                    {card2Label}
                                </p>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>

            {/* Report Table */}
            <Card style={{ borderRadius: "12px", overflow: "hidden" }}>
                <CardBody className="p-0">
                    {/* Column Headers with Totals */}
                    <div className="d-flex" style={{ borderBottom: "1px solid #e9ecef" }}>
                        {/* Date Column Header */}
                        <div
                            style={{
                                width: "80px",
                                minWidth: "80px",
                                padding: "16px 12px",
                                background: "#f8f9fa",
                                borderRight: "1px solid #e9ecef",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "12px",
                                    color: "#6c757d",
                                    margin: 0,
                                    fontWeight: "500",
                                    textAlign: "center",
                                }}
                            >
                                Date
                            </p>
                        </div>

                        {/* Walk in Column */}
                        <div
                            style={{
                                flex: 1,
                                padding: "12px",
                                background:
                                    "linear-gradient(135deg, #f3e8ff 0%, #ede4ff 100%)",
                                borderRight: "2px solid #d8b4fe",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "11px",
                                    color: "#7c3aed",
                                    margin: 0,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Walk in
                            </p>
                            <p
                                style={{
                                    fontSize: "22px",
                                    color: "#7c3aed",
                                    margin: "4px 0 0 0",
                                    fontWeight: "700",
                                }}
                            >
                                {reportTotals?.direct || 0}
                            </p>
                        </div>

                        {/* Web Column */}
                        <div
                            style={{
                                flex: 1,
                                padding: "12px",
                                background:
                                    "linear-gradient(135deg, #e0f2fe 0%, #d6eeff 100%)",
                                borderRight: "2px solid #7dd3fc",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "11px",
                                    color: "#0284c7",
                                    margin: 0,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Web
                            </p>
                            <p
                                style={{
                                    fontSize: "22px",
                                    color: "#0284c7",
                                    margin: "4px 0 0 0",
                                    fontWeight: "700",
                                }}
                            >
                                {reportTotals?.website || 0}
                            </p>
                        </div>

                        {/* Call Column */}
                        <div
                            style={{
                                flex: 1,
                                padding: "12px",
                                background:
                                    "linear-gradient(135deg, #dcfce7 0%, #d1fae5 100%)",
                                borderRight: "2px solid #86efac",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "11px",
                                    color: "#16a34a",
                                    margin: 0,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Call
                            </p>
                            <p
                                style={{
                                    fontSize: "22px",
                                    color: "#16a34a",
                                    margin: "4px 0 0 0",
                                    fontWeight: "700",
                                }}
                            >
                                {reportTotals?.call || 0}
                            </p>
                        </div>

                        {/* Social Column */}
                        <div
                            style={{
                                flex: 1,
                                padding: "12px",
                                background:
                                    "linear-gradient(135deg, #fce7f3 0%, #fce4ec 100%)",
                                borderRight: "2px solid #f9a8d4",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "11px",
                                    color: "#db2777",
                                    margin: 0,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                Social
                            </p>
                            <p
                                style={{
                                    fontSize: "22px",
                                    color: "#db2777",
                                    margin: "4px 0 0 0",
                                    fontWeight: "700",
                                }}
                            >
                                {reportTotals?.social || 0}
                            </p>
                        </div>

                        {/* OLX Column */}
                        <div
                            style={{
                                flex: 1,
                                padding: "12px",
                                background:
                                    "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)",
                                textAlign: "center",
                            }}
                        >
                            <p
                                style={{
                                    fontSize: "11px",
                                    color: "#ea580c",
                                    margin: 0,
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                OLX
                            </p>
                            <p
                                style={{
                                    fontSize: "22px",
                                    color: "#ea580c",
                                    margin: "4px 0 0 0",
                                    fontWeight: "700",
                                }}
                            >
                                {reportTotals?.olx || 0}
                            </p>
                        </div>
                    </div>

                    {/* Table Body */}
                    {loading ? (
                        <div
                            className="d-flex align-items-center justify-content-center w-100"
                            style={{ height: "100" }}
                        >
                            <Spinner color="success" className="d-block m-auto " />
                        </div>
                    ) : (
                        <div style={{}}>
                            {reportData?.result?.map((report, index) => (
                                <div
                                    key={index}
                                    className="d-flex"
                                    style={{
                                        borderBottom: "1px solid #f1f3f4",
                                        background: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                                    }}
                                >
                                    {/* Date */}
                                    <div
                                        style={{
                                            width: "80px",
                                            minWidth: "80px",
                                            padding: "4px 8px",
                                            borderRight: "1px solid #e9ecef",
                                        }}
                                    >
                                        <p
                                            style={{
                                                fontSize: "12px",
                                                color: "#6c757d",
                                                margin: 0,
                                                fontWeight: "500",
                                            }}
                                        >
                                            {moment(report?.date).format("DD MMM")}
                                        </p>
                                    </div>

                                    {/* Walk in */}
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "4px 8px",
                                            textAlign: "center",
                                            borderRight: "1px solid #f3e8ff",
                                        }}
                                    >
                                        <p style={{ fontSize: "12px", color: "#495057", margin: 0 }}>
                                            {report?.direct || 0}
                                        </p>
                                    </div>

                                    {/* Web */}
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "4px 8px",
                                            textAlign: "center",
                                            borderRight: "1px solid #e0f2fe",
                                        }}
                                    >
                                        <p style={{ fontSize: "12px", color: "#495057", margin: 0 }}>
                                            {report?.website || 0}
                                        </p>
                                    </div>

                                    {/* Call */}
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "4px 8px",
                                            textAlign: "center",
                                            borderRight: "1px solid #dcfce7",
                                        }}
                                    >
                                        <p style={{ fontSize: "12px", color: "#495057", margin: 0 }}>
                                            {report?.call || 0}
                                        </p>
                                    </div>

                                    {/* Social */}
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "4px 8px",
                                            textAlign: "center",
                                            borderRight: "1px solid #fce7f3",
                                        }}
                                    >
                                        <p style={{ fontSize: "12px", color: "#495057", margin: 0 }}>
                                            {report?.social || 0}
                                        </p>
                                    </div>

                                    {/* OLX */}
                                    <div
                                        style={{
                                            flex: 1,
                                            padding: "4px 8px",
                                            textAlign: "center",
                                        }}
                                    >
                                        <p style={{ fontSize: "12px", color: "#495057", margin: 0 }}>
                                            {report?.olx || 0}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </CardBody>
            </Card>
        </div>
    )
}

DashboardReportSection.propTypes = {
    reportData: PropTypes.object,
    loading: PropTypes.bool,
    card1Label: PropTypes.string,
    card2Label: PropTypes.string,
}

export default DashboardReportSection
